import { getStoreId } from "$/hooks/use-store-information"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/event/create")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(storeQueries.detail(storeId))
    }
    return {
      crumb: "alfred.pages.event.crumbs.create",
    }
  },
})
